"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _LayoutFormat = _interopRequireDefault(require("./LayoutFormat"));

var _MediaPreview = _interopRequireDefault(require("../../Media/MediaPreview"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  module: {
    position: "relative",
    width: "100%",
    //        paddingBotton: "100%",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "13px",
    lineHeight: 1.5,
    display: "flex",
    flexDirection: "column"
  },
  media: {
    backgroundColor: "grey",
    position: "relative",
    width: "100%"
  },
  content: {
    fontFamily: "Akkurat, sans-serif",
    marginTop: ".25em"
  },
  caption: {},
  headline: {
    fontWeight: "bold"
  },
  byline: {
    fontStyle: "italic"
  },
  license: {}
}));

const ModuleMedia = (_ref) => {
  let mediaType = _ref.mediaType,
      _ref$mediaFormat = _ref.mediaFormat,
      mediaFormat = _ref$mediaFormat === void 0 ? "1:1" : _ref$mediaFormat,
      imageUrl = _ref.imageUrl,
      headline = _ref.headline,
      caption = _ref.caption,
      byline = _ref.byline,
      license = _ref.license,
      props = _objectWithoutPropertiesLoose(_ref, ["mediaType", "mediaFormat", "imageUrl", "headline", "caption", "byline", "license"]);

  const classes = useStyles();
  return _react.default.createElement("article", {
    className: classes.module
  }, _react.default.createElement("figure", {
    className: classes.media
  }, _react.default.createElement(_LayoutFormat.default, {
    format: mediaFormat
  }, _react.default.createElement(_MediaPreview.default, _extends({
    mediaType: mediaType,
    imageUrl: imageUrl
  }, props)))), _react.default.createElement(_Typography.default, {
    component: "figcaption",
    className: classes.content
  }, headline && _react.default.createElement("strong", {
    className: classes.headline
  }, headline, ":"), headline && " ", caption && _react.default.createElement("span", {
    className: classes.caption
  }, caption), byline && " ", byline && _react.default.createElement("em", {
    className: classes.byline
  }, "(", byline, ")"), license && " ", license && _react.default.createElement("em", {
    className: classes.license
  }, license)));
};

var _default = ModuleMedia;
exports.default = _default;
module.exports = exports.default;